import { useEffect, useRef } from "react";
import { MEDIA } from "../media";

/** Brand film player in a native <dialog>. Video loads only when opened. */
export function FilmDialog({ open, onClose, title = "KSS brand film", closeLabel = "Close" }) {
  const dlg = useRef(null);
  const vid = useRef(null);
  const film = MEDIA["film.full"];
  useEffect(() => {
    const d = dlg.current;
    if (!d) return;
    if (open && !d.open) {
      if (typeof d.showModal === "function") d.showModal(); else d.setAttribute("open", "");
      vid.current?.play().catch(() => {});
    }
    if (!open && d.open) { vid.current?.pause(); d.close?.(); d.removeAttribute("open"); }
  }, [open]);
  return (
    <dialog ref={dlg} className="film" aria-label={title} onClose={onClose} onCancel={onClose}
      onClick={(e) => e.target === dlg.current && onClose()}>
      <div className="film-in">
        <div className="film-bar"><p>{title}</p><button type="button" className="tbtn" onClick={onClose}>{closeLabel}</button></div>
        {open && <video ref={vid} src={film.src} poster={film.poster} controls playsInline preload="metadata" />}
      </div>
    </dialog>
  );
}
